export const createSpinner = () => {
    const spinner = document.createElement('div');
    spinner.className = 'spinner-loader';
    spinner.innerHTML = '<div></div>';
    return spinner;
};
